(function ($) {
	var multiSelectArgs = {
		containerHTML: '<div class="multi-select-container">',
		menuHTML: '<div class="multi-select-menu">',
		buttonHTML:
			'<span class="multi-select-button"><svg xmlns="http://www.w3.org/2000/svg" width="10.828" height="6.414" viewBox="0 0 10.828 6.414"><path class="filtering-arrow" id="Path_2" data-name="Path 2" d="M0,0,4.005,4,8,0" transform="translate(1.414 1.414)" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2"/></svg></span>',
		menuItemsHTML: '<div class="multi-select-menuitems">',
		menuItemHTML: '<label class="multi-select-menuitem">',
		presetsHTML: '<div class="multi-select-presets">',
		modalHTML: undefined,
		activeClass: 'multi-select-container--open',
		noneText: 'By Product',
		text: 'Products',
		allText: undefined,
		presets: undefined,
		positionedMenuClass: 'multi-select-container--positioned',
		positionMenuWithin: undefined,
		viewportBottomGutter: 20,
		menuMinHeight: 200,
	};

	if ($('.js-customers-posts').length > 0) {
		// @ts-ignore-next
		$('#filter-customers-outcome-category').multiSelect(
			$.extend({}, multiSelectArgs, {
				// @ts-ignore-next
				noneText: cs_filters_outcomes_label_1,
				// @ts-ignore-next
				text: cs_filters_outcomes_label_2,
			})
		);

		// @ts-ignore-next
		$('#filter-customers-industry-category').multiSelect(
			$.extend({}, multiSelectArgs, {
				// @ts-ignore-next
				noneText: cs_filters_industries_label_1,
				// @ts-ignore-next
				text: cs_filters_industries_label_2,
			})
		);

		listenFiltersSelect();
	}

	function listenFiltersSelect() {
		var filters = ['outcome', 'industry'],
			postsContainer = $('.js-customers-posts');

		// @ts-ignore-next
		$.each(filters, function (i, el) {
			$('#filter-customers-' + el + '-category').change(function () {
				var value = $(this).val(),
					terms = value ? value.toString() : '';

				postsContainer.attr('data-filter-' + el, terms);
				$('#js-customers-update').click();
				displayResetFilters();
			});
		});
	}

	function displayResetFilters() {
		var filtersWrap = $('.js-customers-filters'),
			// @ts-ignore-next
			filterValues = [],
			resetFiltersEl = filtersWrap.children('.js-reset-filters'),
			newResetFiltersEl = $(
				'<li class="js-reset-filters"><button class="multi-select-button reset">' +
					// @ts-ignore-next
					cs_filters_reset_label +
					'</button></li>'
			);

		$('select', filtersWrap).each(function () {
			// @ts-ignore-next
			$.merge(filterValues, $(this).val() || []);
		});

		if (filterValues.length && !resetFiltersEl.length) {
			filtersWrap.append(newResetFiltersEl);
			newResetFiltersEl.find('button').click(function () {
				resetFilters();
			});
		}

		if (!filterValues.length && resetFiltersEl.length) {
			resetFiltersEl.remove();
		}
	}

	function resetFilters() {
		$('select', '.js-customers-filters').each(function () {
			$(this)
				.parent()
				.find('input[type="checkbox"]')
				.each(function () {
					if ($(this).prop('checked')) {
						$(this).click();
					}
				});
		});
	}
})(jQuery);
